export const EDIT_TAGS = "EDIT_TAGS";
export const EDIT_TAGS_SUCCESS = "EDIT_TAGS_SUCCESS";
export const EDIT_TAGS_FAILURE = "EDIT_TAGS_FAILURE";
export const EDIT_TAGS_RESET = "EDIT_TAGS_RESET";
export const EDIT_TAGS_IN_UI = "EDIT_TAGS_IN_UI";
